import React from "react";

const Subheader = ({ heading }) => {
  return (
    <div>
      <h3 style={{ fontWeight: "550" }}>{heading}</h3>
    </div>
  );
};

export default Subheader;
